// global.$ = global.jQuery = require('jquery');
require('./bootstrap');

import 'animate.css';

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

const swiper3 = new Swiper("#workAtV3Swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    // centeredSlides: true,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    }
  });


// // Single slide swiper
// let single_slide_swiper = new Swiper('.single-slide-swiper', {
//   spaceBetween: 25,
//   centeredSlides: true,
//   grabCursor: true,
//   autoplay: {
//     delay: 5000,
//     disableOnInteraction: false,
//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
// });
//
// // 3 Slides swiper
// let three_slide_swiper = new Swiper('.three-slide-swiper', {
//   slidesPerView: 3,
//   spaceBetween: 30,
//   grabCursor: true,
//   autoplay: {
//     delay: 5000,
//     disableOnInteraction: false,
//   },
//   pagination: {
//     el: '.swiper-pagination2',
//     clickable: false,
//   },
//   breakpoints: {
//     // when window width is <= 480px
//     920: {
//       slidesPerView: 2,
//       spaceBetween: 20
//     },
//     461: {
//       slidesPerView: 1,
//       spaceBetween: 0
//     },
//   }
// });
//
// jQuery(document).ready(function () {
//   //used for form validation and movement of placeholders
//   $('input').blur(function () {
//     let tmpval = $(this).val();
//     if (tmpval === '') {
//       $(this).addClass('empty');
//       $(this).removeClass('not-empty');
//     } else {
//       $(this).addClass('not-empty');
//       $(this).removeClass('empty');
//     }
//   });
//
//   $(".file-caption-name").prop("disabled", true); //Disable
// });
//
// // client cco confirmation - move to that page
// jQuery(
//   function ($) {
//     $('#termsBox').on('scroll', function () {
//       if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
//         $('#ccoSignBox').removeClass('disablable-disabled').addClass('disablable-enabled');
//       }
//     });
//   }
// );
//
// // Intercept all responses
// axios.interceptors.response.use(
//  (response) => {
//    // console.log('%c ' + response.status + ' - ' + getUrl(response.config) + ':', 'color: #008000; font-weight: bold', response);
//    return response;
//  },
//  (error) => {
//    if (error.response) {
//      // const status = error.response ? error.response.status : 'No response';
//      // console.log('%c ' + status + ' - :', 'color: #a71d5d; font-weight: bold', error)
//      // router.beforeEach(async (to, from, next) => {
//      //  console.log(to)
//      // });
//      // console.log(router.history.current.path !== '/login')
//      if (419 === error.response.status) {
//        window.location = '/login';
//      }
//
//      // Vue.prototype.$snotify.error('', '', {
//      //  closeOnClick: false,
//      //  showProgressBar: false,
//      //  timeout: 0,
//      //  position: 'centerCenter',
//      //  backdrop: 0.5,
//      //  html: '<div class="snotifyToast__title"><span>CRM ERROR</span></div>' +
//      //   '<div class="snotifyToast__body">' +
//      //   '<p>Please contact IT support and provide them with the information shown below:</p>' + '<hr>' +
//      //   '<div class="error_info">' +
//      //   '<strong>ERROR CODE : </strong>' + status + '<br><br>' +
//      //   '<strong>ERROR DETAILS : </strong><br>' + error +
//      //   '</div>' +
//      //   '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
//      //   '</div>',
//      //  buttons: [
//      //   {text: 'Ok', action: (toast) => {Vue.prototype.$snotify.remove(toast.id);}},
//      //  ]
//      // });
//    }
//
//    return Promise.reject(error);
//  }
// );


window.Vue = require('vue');
import Vue from 'vue';

Vue.component('Csrf', require('../../components/2021/forms/Csrf').default);
Vue.component('GenericError', require('../../components/2021/forms/GenericError').default);
Vue.component('MobileAppForm', require('../../components/2021/forms/MobileAppForm').default);

let page = new Vue({el: '#vue-page'});

import jobResourcingForm from '../../components/2021/jobs/job_resourcing_form';

if (document.getElementById('job-resourcing-form')) {
    new Vue({
        components: {jobResourcingForm},
    }).$mount('#job-resourcing-form');
}